import { regex } from '@/components/validation'

export default ({ value }) => {
  if (value && !value.match(regex.email)) {
    return 'UsersManagement.EmailValidationError'
  }
}



// WEBPACK FOOTER //
// ./src/components/userManagement/validateUserEmail.js